/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachLinkIcon64Regular = forwardRef('AttachLinkIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M19 19c-7.18 0-13 5.82-13 13s5.82 13 13 13h6.5a1.5 1.5 0 0 1 0 3H19c-8.837 0-16-7.163-16-16s7.163-16 16-16h6.5a1.5 1.5 0 0 1 0 3H19Z" }),
        React.createElement("path", { d: "M45 19c7.18 0 13 5.82 13 13s-5.82 13-13 13h-6.5a1.5 1.5 0 0 0 0 3H45c8.837 0 16-7.163 16-16s-7.163-16-16-16h-6.5a1.5 1.5 0 0 0 0 3H45Z" }),
        React.createElement("path", { d: "M19.5 33.5h25a1.5 1.5 0 0 0 0-3h-25a1.5 1.5 0 0 0 0 3Z" })));
});
